import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=1b0e6c7c&scoped=true&"
import script from "./Navigation.vue?vue&type=script&lang=js&"
export * from "./Navigation.vue?vue&type=script&lang=js&"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=1b0e6c7c&lang=scss&rel=stylesheet%2Fscss&scoped=true&"
import style1 from "./Navigation.vue?vue&type=style&index=1&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0e6c7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/clients/client11/web18/web/api/releases/20220610210856/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b0e6c7c')) {
      api.createRecord('1b0e6c7c', component.options)
    } else {
      api.reload('1b0e6c7c', component.options)
    }
    module.hot.accept("./Navigation.vue?vue&type=template&id=1b0e6c7c&scoped=true&", function () {
      api.rerender('1b0e6c7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/src/components/expert/Navigation/Navigation.vue"
export default component.exports